import * as React from 'react';
import './styles.css';

interface IItem {
  key: string;
  title: JSX.Element | string;
  icon?: JSX.Element | string;
  addClass?: string;
}

export interface IBaseSegmentedProps {
  items: IItem[];
  tabDefaul?: string;
  tab?: string;
  onClick?: (_key: string) => any;
}

export default function BaseSegmented(props: IBaseSegmentedProps) {
  const { items, tab, tabDefaul = '', onClick = () => {} } = props;
  const [active, setActive] = React.useState<string>(tabDefaul);

  React.useEffect(() => {
    if (items.map((i) => i.key).includes(tab as string)) {
      setActive(tab as string);
    }
  }, [items, tab]);

  return (
    <>
      <div className="flex rounded-3xl overflow-hidden bg-white shadow w-fit">
        {items.map((item: IItem, i: number) => {
          return (
            <div
              key={i.toString()}
              className={`flex z-10 items-center px-4 p-1 relative flex-1 whitespace-nowrap cursor-pointer scroll-snap-none ${
                active === item.key ? 'bg-mint-1 text-mint-13' : 'phr-button-h'
              } ${item.addClass}`}
              onClick={() => {
                onClick(item.key);
                !tab && setActive(item.key);
              }}
            >
              {item.icon}
              {item.title}
            </div>
          );
        })}
      </div>
    </>
  );
}
